<template xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <v-container :fill-height="loading" class="user-settings" fluid pt-0>
    <v-app-bar app color="black" dark fixed>

      <template v-if="$vuetify.breakpoint.mdAndDown">
        <hb-main-menu-button/>
      </template>

      <v-toolbar-title v-if="!loading" style="margin-left: 0">{{ $t('user_settings.title') }}</v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>

    <hb-loading-indicator v-if="loading" align-middle fill-height></hb-loading-indicator>

    <v-fade-transition hide-on-leave>
      <v-row v-if="!loading">
        <v-col class="user-settings-holder" cols="12" offset-xl="2" xl="8">
          <v-row>
            <v-col cols="12" md="8" offset-md="2">
              <v-card color="#191919" outlined>
                <v-card-title class="pb-0" primary-title>
                  <div>
                    <div class="mb-0">{{ $t('user_settings.push_notifications') }}</div>
                  </div>
                </v-card-title>
                <v-card-text>
                  {{ $t('user_settings.push_notifications_explained') }}
                </v-card-text>
                <v-card-actions>
                  <v-switch
                      v-model="pushNotificationsEnabled"
                      :label="$t('user_settings.allow_notifications')"
                      class="mt-0 mb-2 ml-2"
                      color="primary"
                      hide-details
                      @change="updateNotificationSettings"
                  ></v-switch>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-fade-transition>
  </v-container>
</template>

<script>
import api from '../apicollection';

export default {
  name: 'UserSettingsView',
  data() {
    return {
      loading: true,
      pushNotificationsEnabled: false,
    };
  },
  computed: {},
  methods: {
    async updateNotificationSettings() {
      try {
        const user = await api.updateUserSelf(this.$user.id, {
          language: this.$user.language,
          pushNotificationsEnabled: this.pushNotificationsEnabled,
        });
        this.$setUser(user);
      } catch (e) {
        console.log(e);
        this.$showErrorNotification(this.$t('errors.error_updating_push_notification_settings'), false);
      }
      this.pushNotificationsEnabled = this.$user.pushNotificationsEnabled;
    },
  },
  mounted() {
    this.loading = false;

    this.pushNotificationsEnabled = this.$user.pushNotificationsEnabled;

    this.$vuetify.goTo(0, {
      duration: 0,
      offset: 0,
    });
  },
};
</script>

<style lang="scss" scoped></style>
